import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Spinner,
} from "reactstrap";
import ErrorMessage from "../../components/comman/ErrorMessage";
import { apiUrl } from "../../ApiHelper/ApiUrl";
import { toast } from "react-toastify";
import { callApi } from "../../ApiHelper/ApiHelper";

const AddTeamModal = ({ modal, toggle, siteId, GetSiteTeam }) => {
  // console.log("modalData>>>>>>>>", modalData);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedSeniorLevel, setSelectedSeniorLevel] = useState("");
  const [usersByLevel, setUsersByLevel] = useState({
    seniorUsers: [],
    juniorUsers: [],
  });

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const closeHandler = () => {
    toggle();
    reset();
  };

  const GetUsersByLevel = (level, type) => {
    let options = {
      method: "GET",
    };
    let API = apiUrl.site_users + `?siteId=${siteId}&level=${level}`;
    callApi(API, options).then((response) => {
      if (response?.status === true) {
        if (type === "seniorUser") {
          setUsersByLevel((prev) => ({
            ...prev,
            seniorUsers: response?.data?.user,
          }));
          setSelectedSeniorLevel(level);
        }
        if (type === "juniorUser") {
          setUsersByLevel((prev) => ({
            ...prev,
            juniorUsers: response?.data?.user,
          }));
        }
      }
    });
  };

  const onSubmit = (data) => {
    const submitData = {
      siteId: siteId,
      seniorEmployeeId: data?.seniorEmployeeId,
      juniorEmployeeId: data?.juniorEmployeeId,
    };
    // console.log("submitData>>>>.", submitData);

    const options = {
      method: "POST",
      data: submitData,
    };

    let API = apiUrl?.create_team;
    setIsLoading(true);
    callApi(API, options).then((response) => {
      setIsLoading(false);
      if (response?.status === true) {
        toast.success(response?.message);
        GetSiteTeam();
        closeHandler();
      } else {
        toast.error(response?.message);
      }
    });
  };

  const teamLevel = [
    { value: 1, label: '1 - Plant Head' },
    { value: 2, label: '2 - Deputy manager' },
    { value: 3, label: '3 - Assistant manager' },
    { value: 4, label: '4 - Sr.Engineer' },
    { value: 5, label: '5 - Engineer' },
    { value: 6, label: '6 - Sr.Technician' },
    { value: 7, label: '7 - Technician' },
    { value: 8, label: '8 - Helper' },
    { value: 9, label: '9 - Office Boy / Cook / Driver' },
  ]

  return (
    <Modal
      className="modal-dialog modal-dialog-scrollable modal-dialog-centered"
      isOpen={modal}
      toggle={closeHandler}
      centered
    >
      <ModalHeader toggle={closeHandler}>
        Create Team
      </ModalHeader>

      <form onSubmit={handleSubmit(onSubmit)}>
        <ModalBody className="p-4">
          <div className="modal-content">
            <div className="row">
              {/* Senior Employee Level */}
              <div className="col-4">
                <div className="form-group mb-3">
                  <label htmlFor="seniorEmployeeLevel" className="form-label">
                    Level
                  </label>
                  <select
                    className="form-select"
                    {...register("seniorEmployeeLevel", {
                      required: "Please select level",
                    })}
                    onChange={(e) => {
                      GetUsersByLevel(e.target.value, "seniorUser");
                    }}
                  >
                    <option value="">Select Level</option>
                    {teamLevel.map((level) => (
                      <option key={level?.value} value={level?.value}>
                        {level?.label}
                      </option>
                    ))}
                  </select>
                  <ErrorMessage
                    message={errors?.seniorEmployeeLevel?.message}
                  />
                </div>
              </div>

              {/* Senior Employee */}
              <div className="col-8">
                <div className="form-group mb-3">
                  <label htmlFor="seniorEmployeeId" className="form-label">
                    Senior Employee
                  </label>
                  <select
                    className="form-select"
                    {...register("seniorEmployeeId", {
                      required: "Please select a senior employee",
                    })}
                  >
                    <option value="" className="d-none">
                      Select Senior Employee
                    </option>
                    {usersByLevel?.seniorUsers?.length > 0 ?
                      usersByLevel?.seniorUsers?.map((item) => (
                        <option key={item.id} value={item.userId}>
                          {`${item.user?.name} - (${item?.user?.designation?.name})`}
                        </option>
                      )) :
                      <option value="" disabled>--No employee in selected level--</option>
                    }
                  </select>
                  <ErrorMessage message={errors?.seniorEmployeeId?.message} />
                </div>
              </div>

              {/* Junior Employee Level */}
              <div className="col-4">
                <div className="form-group mb-3">
                  <label htmlFor="juniorEmployeeLevel" className="form-label">
                    Level
                  </label>
                  <select
                    className="form-select"
                    {...register("juniorEmployeeLevel", {
                      required: "Please select level",
                    })}
                    onChange={(e) => {
                      GetUsersByLevel(e.target.value, "juniorUser");
                    }}
                  >
                    <option value="">Select Level</option>
                    {teamLevel
                      .filter((level) => level?.value > selectedSeniorLevel)
                      .map((level) => (
                        <option key={level?.value} value={level?.value}>
                          {level?.label}
                        </option>
                      ))}
                  </select>
                  <ErrorMessage
                    message={errors?.juniorEmployeeLevel?.message}
                  />
                </div>
              </div>

              {/* Junior Employee */}
              <div className="col-8">
                <div className="form-group mb-3">
                  <label htmlFor="juniorEmployeeId" className="form-label">
                    Junior Employee
                  </label>
                  <select
                    className="form-select"
                    {...register("juniorEmployeeId", {
                      required: "Please select a junior employee",
                    })}
                  >
                    <option value="" className="d-none">
                      Select Junior Employee
                    </option>
                    {usersByLevel?.juniorUsers?.length > 0 ?
                      usersByLevel?.juniorUsers?.map((item) => (
                        <option key={item.id} value={item.userId}>
                          {`${item.user?.name} - (${item?.user?.designation?.name})`}
                        </option>
                      )) :
                      <option value="" disabled>--No employee in selected level--</option>
                    }
                  </select>
                  <ErrorMessage message={errors?.juniorEmployeeId?.message} />
                </div>
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={closeHandler}
          >
            Close
          </button>
          <button type="submit" className="btn btn-primary">
            {isLoading ? <Spinner /> : "Create"}
          </button>
        </ModalFooter>
      </form>
    </Modal>
  );
};

export default AddTeamModal;
